module.exports = __webpack_public_path__ + "static/media/tnt.dd8b288d.svg";